import { render, staticRenderFns } from "./List.vue?vue&type=template&id=440f9a3c"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440f9a3c')) {
      api.createRecord('440f9a3c', component.options)
    } else {
      api.reload('440f9a3c', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=440f9a3c", function () {
      api.rerender('440f9a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/user/List.vue"
export default component.exports